var _linearGradient, _linearGradient2, _linearGradient3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLogo = function SvgLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Editable Icons",
    viewBox: "0 0 128 128"
  }, props), /*#__PURE__*/React.createElement("defs", null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "logo_svg__a",
    x1: 63.98,
    x2: 63.98,
    y1: 61.31,
    y2: 18.66,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#fff",
    stopOpacity: 0.06
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#fff",
    stopOpacity: 0.23
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#fff",
    stopOpacity: 0.49
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#fff",
    stopOpacity: 0.85
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#fff"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "logo_svg__b",
    x1: 64.35,
    x2: 64.35,
    y1: 63.06,
    y2: 112.19,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#fff",
    stopOpacity: 0.03
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#fff",
    stopOpacity: 0.08
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#fff",
    stopOpacity: 0.09
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#fff",
    stopOpacity: 0.41
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#fff",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#fff",
    stopOpacity: 0.71
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#fff",
    stopOpacity: 0.92
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#fff"
  }))), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "logo_svg__d",
    x1: 9.76,
    x2: 118.52,
    y1: 120.04,
    y2: 11.28,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#42c1ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#2aafff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#0b98ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#0090ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#1130b3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#1b008e"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "logo_svg__c",
    width: 115.57,
    height: 101.95,
    x: 6.35,
    y: 14.68,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.92 59.57C7.36 33.62 39.03 7.79 64.13 32.89c24.39-24.39 55.63.76 44.39 26.1",
    style: {
      fill: "none",
      strokeMiterlimit: 10,
      strokeWidth: 8,
      stroke: "url(#logo_svg__a)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m104.78 65.89-40.65 40.65-40.21-40.21",
    style: {
      stroke: "url(#logo_svg__b)",
      fill: "none",
      strokeMiterlimit: 10,
      strokeWidth: 8
    }
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mask: "url(#logo_svg__c)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.35 14.68h115.57v101.95H6.35z",
    style: {
      fill: "url(#logo_svg__d)",
      strokeWidth: 0
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M121.92 64h-30.4L78.08 44.53 57.01 70.65 43.74 54l-8.4 10H10.08",
    style: {
      fill: "none",
      strokeMiterlimit: 10,
      strokeWidth: 8,
      stroke: "#140089"
    }
  }));
};
export default SvgLogo;